export default __webpack_public_path__ + "static/media/manager-w.7e057788.png";